export const environment = {
  production: false,
  apiRoot: 'https://evolution-erp.systems/staging/',
  miniMenuPublicRoot: 'https://menustaging.hungery.id',
  miniMenuDefaultSlug: 'hungery-cafe',
  hungeryPublicRoot: 'https://staging.hungery.id',
  miniMenuFallback: {
    slug: 'hungery-cafe',
    businessPartnerId: 11653,
    branchId: 374,
    businessName: 'HUNGERY Cafe'
  },
  clientId: "BLISSWEB",
  instaRedirectURL: "https://staging.hungery.id/insta-callback",
  instaClientId: "1080018843446470",
  instaSecretKey: "6e06c9474a12a2914bbab1722194b691",
  whatsAppInquiryNumber: '6282128321509',
  registrationGeoRestrictionEnabled: false,
  registrationAllowedCountries: ['Indonesia'],
  registrationApprovalRequired: true,
  // Used only by a real phone browser. Desktop keeps the Firebase-hosted popup callback,
  // while the Flutter WebView is detected by its native JavaScript bridge and bypasses
  // Firebase web login entirely.
  mobileBrowserAuthDomain: "staging.hungery.id",
  firebase: {
    apiKey: "AIzaSyDC5cV8hKGhdks90zWzwZ9zY4N3uNuV9sk",
    // Previously authorized callback retained for the desktop popup flow.
    authDomain: "hungery-441404.firebaseapp.com",
    projectId: "hungery-441404",
    storageBucket: "hungery-441404.firebasestorage.app",
    messagingSenderId: "246346042219",
    appId: "1:246346042219:web:953aeb06b42edf0b3c1a2e",
    measurementId: "G-W3L4YMLP9N"
  },
};
